import React, { FunctionComponent, SVGProps } from 'react'

export const IconEyeOff: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    stroke="#858591"
    strokeWidth="1.5"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.23344 8.73328C7.98782 8.96215 7.79081 9.23815 7.65417 9.54482C7.51753 9.85148 7.44406 10.1825 7.43813 10.5182C7.43221 10.8539 7.49396 11.1873 7.6197 11.4986C7.74543 11.8099 7.93258 12.0927 8.16998 12.3301C8.40737 12.5675 8.69015 12.7546 9.00145 12.8804C9.31274 13.0061 9.64617 13.0678 9.98185 13.0619C10.3175 13.056 10.6486 12.9825 10.9552 12.8459C11.2619 12.7092 11.5379 12.5122 11.7668 12.2666"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.94165 4.73329C9.29274 4.68955 9.64618 4.66729 9.99998 4.66663C15.8333 4.66663 18.3333 10.5 18.3333 10.5C17.9607 11.2976 17.4935 12.0474 16.9417 12.7333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.50841 6.0083C3.85112 7.13715 2.52497 8.68768 1.66675 10.5C1.66675 10.5 4.16675 16.3333 10.0001 16.3333C11.5967 16.3376 13.1591 15.8709 14.4917 14.9916"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66675 2.16663L18.3334 18.8333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
